/* eslint-disable no-restricted-syntax */
import { splitPath } from '@tencent/data-schema-core/lib/utils/path';
import { get, isPlainObject } from "lodash-es";
import { builtinCollectDepsVisitors } from './builtinVisitors';
import { Dep } from './Dep';
import { getDepsFromExpression } from './getDepsFromExpression';
/** 遍历对象/数组里的全部字符串，会嵌套深层遍历 */
function* walkObjectStrings(value, place = []) {
  if (typeof value === 'string') {
    yield {
      value,
      place
    };
  }
  if (typeof value !== 'object') return;
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) yield* walkObjectStrings(value[i], [...place, i]);
  }
  if (isPlainObject(value)) {
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        yield* walkObjectStrings(value[key], [...place, key]);
      }
    }
  }
}
/**
 * 遍历整个 Layout 树，收集它的依赖，详细见 README.md
 */
export function* collectDeps(ctx, startPoint) {
  const queue = [{
    place: [],
    ...startPoint
  }];
  const allVisitors = [...builtinCollectDepsVisitors, ...(ctx.visitors || [])];
  while (queue.length) {
    const step = queue.pop();
    for (const visitor of allVisitors) try {
      for (const report of visitor(ctx, step)) {
        const {
          type,
          place: partialPlace
        } = report;
        const value = get(step.value, partialPlace);
        if (!value) continue;
        const place = [...step.place, ...partialPlace];
        switch (type) {
          case 'pagelet':
          case 'layout':
          case 'eventFlow':
          case 'eventFlowStep':
            queue.push({
              type,
              value,
              place
            });
            break;
          case 'dataPath':
            yield new Dep({
              dataPath: splitPath(value),
              description: report.description,
              place,
              start: 0,
              end: value.length
            });
            break;
          case 'javascript':
          case 'interopable':
          case 'interopable-string':
            {
              const modeForField = type === 'javascript' ? 'javascript' : 'interopable-string';
              for (const {
                value: fieldValue,
                place: fieldPlace
              } of walkObjectStrings(value, place)) {
                for (const dep of getDepsFromExpression(ctx, fieldValue, modeForField)) {
                  dep.description = `${report.description} ${dep.description}`;
                  dep.place = fieldPlace;
                  dep.accessType = report.accessType;
                  yield dep;
                }
              }
              break;
            }
          default:
            {
              // 这是一个类型守护，一般情况 TS 不会报错，除非上面漏了什么 case
              // eslint-disable-next-line
              const typeIsNotFullyCovered = type;
            }
        }
      }
    } catch (e) {
      console.error('[UICore] Failed to invoke visitor', e, visitor);
    }
  }
}
//# sourceMappingURL=collectDeps.js.map
